<template>
    <router-link class="db-btn-outline sm default primary transparent modal-btn m-0.5"
        :to="{ name: this.$props.link, params: { id: this.$props.id } }">
        <i class="lab lab-line-eye"></i> 
        <span class="db-tooltip">{{ $t('button.view') }}</span>
    </router-link>
</template>

<script>
export default {
    name: "SmViewComponent",
    props: {
        link: String,
        id: Number
    }
}
</script>

<style scoped>

</style>
